import { createUseStyles } from 'react-jss';

const styles = {
  dateInput: {
    '&:first-child': {
      marginRight: '3rem',
    },
  },
  adminViewToggle: {
    marginLeft: '15%',
    // for centering toggle relative to the input field
    marginBottom: '0.4rem',
  },
};
const createStyles = createUseStyles(styles);

export { createStyles };
